import { CommonModule } from '@angular/common';
import { Component, Input, HostListener, OnInit } from '@angular/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-polar-chart',
  imports: [
    CommonModule,
    NgxChartsModule
  ],
  templateUrl: './polar-chart.component.html',
  styleUrl: './polar-chart.component.scss'
})
export class PolarChartComponent implements OnInit {
  @Input() polarChartData: any[] = [];
  view: [number, number] = [500, 500];

  ngOnInit() {
    this.setResponsiveView();
  }

  @HostListener('window:resize')
  onResize() {
    this.setResponsiveView();
  }

  setResponsiveView() {
    const width = window.innerWidth;
    if (width < 480) {
      this.view = [250, 250];
    } else if (width < 768) {
      this.view = [320, 320];
    } else if (width < 1024) {
      this.view = [400, 400];
    } else {
      this.view = [500, 500];
    }
  }

  xAxisLabel: string = 'Year';
  yAxisLabel: string = 'Population';

  // colorScheme = {
  //   domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
  // };

  constructor() {
    Object.assign(this.polarChartData);
  }

  onSelect(event: any) {
    // console.log(event);
  }
}
